var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -571.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_analytics",
    transform: "translate(61.000000, 571.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,20 L14,20 L14,5 C14,4.44771525 13.5522847,4 13,4 L12,4 C11.4477153,4 11,4.44771525 11,5 L11,20 L11,20 Z M5,20 L8,20 L8,13 C8,12.4477153 7.55228475,12 7,12 L6,12 C5.44771525,12 5,12.4477153 5,13 L5,20 L5,20 Z M17,10 L17,20 L17,20 L20,20 L20,10 C20,9.44771525 19.5522847,9 19,9 L18,9 C17.4477153,9 17,9.44771525 17,10 Z",
    id: "Shape",
    fill: "#616674",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalytics);
export default __webpack_public_path__ + "static/media/ic_analytics.ed0fa40ef0c848819eb90b4795beb4b6.svg";
export { ForwardRef as ReactComponent };